import { splitLines, unquote } from '../detect.js';
const PARTICIPANT_RE = /^\s*(?:participant|actor)\s+(\S+)(?:\s+as\s+(.+?))?\s*$/;
const NOTE_RE = /^\s*Note\s+(over|left of|right of)\s+([^:]+):\s*(.+)$/i;
// Match: From ->> To: label   or   From -> To : label  or  From --> To : label  or  From -->> To
const MESSAGE_RE = /^\s*(\S+?)\s*(?:(-+[ox]?>>?|-+[ox]?|=+>|-\.->|-\.-+>|~+>|:>+|=+>))\s*(\S+)\s*(?::\s*(.+?))?\s*$/;
export const parseSequence = (source) => {
    const lines = splitLines(source);
    const participants = new Map();
    const messages = [];
    const notes = [];
    const ensure = (id, label, isActor = false) => {
        const key = id.trim();
        if (!participants.has(key)) {
            participants.set(key, { id: key, label: unquote(label ?? key), isActor });
        }
        else if (label) {
            const existing = participants.get(key);
            existing.label = unquote(label);
            existing.isActor = existing.isActor || isActor;
        }
    };
    for (const raw of lines) {
        const line = raw.trim();
        if (!line || /^sequenceDiagram/i.test(line))
            continue;
        const part = PARTICIPANT_RE.exec(line);
        if (part) {
            ensure(part[1], part[2], /^actor/i.test(line));
            continue;
        }
        const note = NOTE_RE.exec(line);
        if (note) {
            const at = note[2].trim();
            const text = note[3].trim();
            if (/^over\b/i.test(note[1]))
                notes.push({ at, text, side: 'over' });
            else if (/^left of/i.test(note[1]))
                notes.push({ at, text, side: 'left' });
            else
                notes.push({ at, text, side: 'right' });
            for (const p of at.split(',').map((s) => s.trim()))
                ensure(p);
            continue;
        }
        const m = MESSAGE_RE.exec(line);
        if (m) {
            const from = m[1].trim();
            const arrow = m[2];
            const to = m[3].trim();
            const label = (m[4] ?? '').trim();
            if (from && to) {
                ensure(from);
                ensure(to);
                messages.push({
                    from,
                    to,
                    label,
                    dashed: /^--/.test(arrow),
                    async: />>/.test(arrow),
                });
            }
        }
    }
    const nodes = Array.from(participants.values()).map((p) => ({
        id: p.id,
        label: p.label,
        shape: p.isActor ? 'person' : 'rect',
        layer: 'actor',
    }));
    const edges = messages.map((m, idx) => ({
        id: `e_${idx}_${m.from}_${m.to}`,
        from: m.from,
        to: m.to,
        label: m.label || undefined,
        style: m.dashed ? 'dashed' : 'solid',
        arrowEnd: 'arrow',
    }));
    return {
        type: 'sequence',
        nodes,
        edges,
        groups: [],
        styles: {},
        meta: { notes, messages },
    };
};
//# sourceMappingURL=sequence.js.map